import { atom } from "jotai";

export const savedItemHeaderInfoAtom = atom<{ title: string | null; count: number | null }>({
  title: null,
  count: null,
});
